<template>
  <div>
    <br>
    <VueTimeline 
      :timeline-items="dataForTimeline"
      :individualClasses="true" 
    />
    <button v-if="showNumber <= dataForTimeline.length" v-on:click="incrementCount">Show More</button>
  </div>
</template>

<script>
import VueTimeline from 'bs-vue-timeline'
// import TimeLineContent from './TimeLineContent.vue'
import '../assets/state.css'

const SHOOT = ["beanbag", "rubber bullets", "pepper bullets", "deterrent rounds", "projectiles", "real bullets", "tear gas canister"]
const GAS = ["tear gas", "mace", "tear gas canister", "pepper spray"]
const ASSAULT = ["shove", "beat", "tackle", "knee", "push", "choke", "batons", "shields", "throw"]

const PROPERTY = ["property destruction"]
const CAR = ["SUV", "policecar", "horse", "bike"]
const TAZE = ["taser", "stun gun"]
const EXPLOSIVE = ["explosive", "flashbangs", "paint cannister"]

const TWITTER = /twitter/

export default {
  components: {
    VueTimeline
  },
  props: {
    state: String,
    stateData: Array,
  },
  data: function () {
    return {
      showNumber: 10
    }
  },
  methods: {
    incrementCount: function() {
      this.showNumber += 10
    }
  },
  computed: {
    dataForTimeline: function() {
      function buildContent(item) {
        const desc = item.name + `<br>`
        const twitterlinks = item.links.filter(function (str) { return TWITTER.test(str); });
        var tweet = ""
        if (twitterlinks.length && Array.isArray(twitterlinks)) {
          tweet = `<center><iframe src="https://twitframe.com/show?url=${twitterlinks[0]}" width="100%" height="450px" style="border:none;overflow:hidden" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe></center>`;
        }
        const alllinks = item.links.map(function(url, ind) { return ` <a href=${url}>link ${ind + 1}</a>`})

        return desc + tweet + `Additional links: <br>` + alllinks
      }

      function buildAsset(item) {
        const is_car = item.tags.filter(value => CAR.includes(value)).length;
        const is_property = item.tags.filter(value => PROPERTY.includes(value)).length;
        const is_taze = item.tags.filter(value => TAZE.includes(value)).length;
        const is_explode = item.tags.filter(value => EXPLOSIVE.includes(value)).length;
        const is_shoot = item.tags.filter(value => SHOOT.includes(value)).length;
        const is_gas = item.tags.filter(value => GAS.includes(value)).length;
        const is_assault = item.tags.filter(value => ASSAULT.includes(value)).length
        if ((is_shoot && is_gas) || (is_shoot && is_assault) || (is_gas && is_assault)) {
          return "combination.png"
        } else if (is_shoot) {
          return "shoot.png"
        } else if (is_taze) {
          return "taze.png"
        } else if (is_explode) {
          return "bomb.png"
        } else if (is_gas) {
          return "spray.png"
        } else if (is_assault) {
          return "beat.png"
        } else if (is_property) {
          return "house.png"
        } else if (is_car) {
          return "car.png"
        } else {
          return "other.png"
        }
      }
      return this.stateData.slice().sort(function(a,b){ 
        var x = a.date > b.date? -1:1; 
        return x;
      }).slice(0, this.showNumber).map(function(item) {
        var d = item.date_text === "" ? "No Date" : item.date_text;
        const content = buildContent(item);
        const asset = buildAsset(item)
        return {title: d, subtitle: item.city, content: content, image: asset};
      })
    }
  }
}
</script>

<style scoped>
</style>